import React from "react";
import ReactDOM from "react-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { AppStateProvider } from "./contextProviders/index";
import App from "./App.jsx";
import { MsalProvider } from "@azure/msal-react";

import "./styles/index.css";

/**
 * If this window is the QBO OAuth popup, relay the callback URL to the parent
 * and close immediately — before MSAL or React can navigate the window away.
 *
 * We use window.name (set to "oauthPopup" by window.open) as a COOP-resistant
 * identifier so the parent window (which has a different name) is never affected.
 */
const searchParams = new URLSearchParams(window.location.search);
const isQboOauthPopup =
  window.name === "oauthPopup" &&
  localStorage.getItem("QBO_OAUTH_POPUP") === "true" &&
  window.location.pathname.includes("qbo-accounting/oauth-callback") &&
  (searchParams.has("code") || searchParams.has("error"));

if (isQboOauthPopup) {
  localStorage.setItem("QBO_OAUTH_CALLBACK_URL", window.location.href);
  window.close();
} else {
  /**
   * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
   * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
   */
  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();

  ReactDOM.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AppStateProvider>
          <App />
        </AppStateProvider>
      </MsalProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
}
